export const allProvidersToken = 'all' as const;
export const displayedProvidersToken = 'displayed' as const;

export type AllProvidersToken = typeof allProvidersToken;
export type DisplayedProvidersToken = typeof displayedProvidersToken;
export type ProviderFilter = number[] | AllProvidersToken;
export type ProviderFilterSearchValue = ProviderFilter | DisplayedProvidersToken;

export function toProviderIdParam(providerFilter: ProviderFilter): number[] | undefined {
  return providerFilter === allProvidersToken ? undefined : providerFilter;
}
